import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiPoll } from '@tytapp/api';


@Component({
    selector: 'tyt-petition-card',
    templateUrl: './petition-card.component.html',
    styleUrls: ['./petition-card.component.scss']
})
export class PetitionCardComponent {
    @Input() petition: ApiPoll;
    @Input() image: boolean;
    @Input() info: boolean;
    @Input() placeholder: boolean;

    @Output()
    deletePetitionEvent = new EventEmitter<ApiPoll>();

    deletePetition() {
        if (confirm('Are you sure you want to delete the petition?')) {
            this.deletePetitionEvent.emit(this.petition);
        }
    }
}
